import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDown, ChevronUp, CircleAlert, Replace, Link, FilePenLine, Wrench, LayoutDashboard,Zap, Database,LogOut, Orbit } from 'lucide-react';
import styles from './SidebarItem.module.css';

const IconMap = {
  CircleAlert,
  Wrench,
  FilePenLine,
  Replace,
  LayoutDashboard,
  Zap,
  Link,
  Database,
  Orbit,
  LogOut
};

export const SidebarItem = ({ 
  item, 
  isCollapsed, 
  onToggle, 
  onItemClick 
}) => {
  const { id, label, icon, active, hasSubItems, expanded, subItems } = item;
  const IconComponent = IconMap[icon] || null;

  const hasActiveSubItem = hasSubItems && subItems?.some(si => si.active);

  const handleClick = () => {
    if (hasSubItems) {
      onToggle(id);
    } else {
      onItemClick(item); 
    }
  };

  return (
    <div className={styles.sidebarItem}>
      <button
        className={`${styles.itemButton} ${active ? styles.active : ''} ${hasActiveSubItem && !active ? styles.hasActiveChild : ''}`}
        onClick={handleClick}
        aria-expanded={!!expanded}
        aria-haspopup={hasSubItems ? 'true' : undefined}
      >
        <div className={styles.itemContent}>
          <div className={styles.iconAndLabel}>
            {IconComponent && <IconComponent className={styles.icon} />}
            {!isCollapsed && <span className={styles.label}>{label}</span>}
          </div>
          {!isCollapsed && hasSubItems && (
            <div className={styles.expandIcon}>
              {expanded ? (
                <ChevronUp className={styles.chevron} />
              ) : (
                <ChevronDown className={styles.chevron} />
              )}
            </div>
          )}
        </div>
      </button>

      {hasSubItems && expanded && !isCollapsed && (
        <div className={styles.subItems}>
          {subItems?.map((subItem) => {
            const SubIcon = IconMap[subItem.icon] || null;
            // Disable CMDB and Knowledge Centre for now
            const isDisabled = ["cmdb", "knowledgeCentre"].includes(subItem.id);
            const isNavigable = !!subItem.path && !isDisabled;
            return (
              <button
                key={subItem.id}
                className={`${styles.subItem} ${isDisabled ? styles.disabled : ''} ${subItem.active ? styles.active : ''}`}
                onClick={isNavigable ? () => onItemClick(subItem) : (e) => e.preventDefault()}
                disabled={isDisabled || !isNavigable}
                tabIndex={isDisabled ? -1 : (isNavigable ? 0 : -1)}
                style={{ fontWeight: 'normal' }}
              >
                {SubIcon && <SubIcon className={styles.subIcon} size={16} />}
                {subItem.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

SidebarItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    active: PropTypes.bool,
    hasSubItems: PropTypes.bool,
    expanded: PropTypes.bool,
    subItems: PropTypes.array
  }).isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onItemClick: PropTypes.func.isRequired
};